import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  hotelRoom: {
    data: [],
    meta: {
      total: 0,
    },
  },
  mainHotelRoom: [],
};

// TODO: fetch all the hotelRoom
export const fetchHotelRoom = createAsyncThunk(
  "fetchHotelRoom/hotelRoom",
  async ({ enqueueSnackbar, limit = 10, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`hotel-rooms`, {
        params: {
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create hotelRoom
export const createHotelRoom = createAsyncThunk(
  "createHotelRoom/hotelRoom",
  async (
    { data, enqueueSnackbar, handleClose, activeTab, setActiveTab },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.post(`hotel-rooms`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        activeTab,
        setActiveTab,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update hotelRoom
export const updateHotelRoom = createAsyncThunk(
  "updateHotelRoom/hotelRoom",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`hotel-rooms/${id}`, data);
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete hotelRoom
export const deleteHotelRoom = createAsyncThunk(
  "deleteHotelRoom/hotelRoom",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`hotel-rooms/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const hotelRoomlice = createSlice({
  name: "hotelRoom",
  initialState,
  reducers: {
    resetLoadings: (state) => {
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: get hotelRoom
    builder.addCase(fetchHotelRoom.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchHotelRoom.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.hotelRoom.data = action.payload.data;
      state.hotelRoom.meta.total = action.payload.meta.total;
    });

    builder.addCase(fetchHotelRoom.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create hotelRoom
    builder.addCase(createHotelRoom.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createHotelRoom.fulfilled, (state, action) => {
      state.isLoading = false;
      state.hotelRoom.data = [action.payload.data, ...state.hotelRoom.data];
      state.hotelRoom.meta.total = state.hotelRoom.meta.total + 1;
      action.payload.enqueueSnackbar("HotelRoom is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createHotelRoom.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update hotelRoom
    builder.addCase(updateHotelRoom.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateHotelRoom.fulfilled, (state, action) => {
      state.isLoading = false;
      state.hotelRoom.data = state?.hotelRoom?.data?.map((hotelRoom) => {
        if (hotelRoom.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return hotelRoom;
        }
      });
      action.payload.enqueueSnackbar("HotelRoom is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateHotelRoom.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete hotelRoom
    builder.addCase(deleteHotelRoom.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteHotelRoom.fulfilled, (state, action) => {
      state.isLoading = false;
      state.hotelRoom.data = state.hotelRoom.data.filter(
        (hotelRoom) => hotelRoom.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("HotelRoom is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteHotelRoom.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default hotelRoomlice.reducer;

export const { resetLoadings } = hotelRoomlice.actions;
